var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.667 13.333A6.666 6.666 0 1 1 6.667 0a6.666 6.666 0 0 1 0 13.333Zm0-1.333a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667Zm-.665-2.667L3.173 6.505l.943-.943 1.886 1.886 3.77-3.771.944.942-4.714 4.714Z",
  fill: "currentColor"
})));
export { SvgCheckCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/13150d96.svg";